import type { SVGProps } from "react";
const SvgFileSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.25}
      d="m17.5 18.333-1.79-1.789m0 0q.144-.143.266-.306a2.857 2.857 0 1 0-.265.306Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M9.167 18.333h-.228c-2.717 0-4.076 0-5.02-.664q-.407-.288-.713-.671C2.5 16.109 2.5 14.83 2.5 12.273v-2.121c0-2.47 0-3.704.39-4.69.629-1.586 1.958-2.836 3.642-3.427 1.048-.368 2.36-.368 4.983-.368 1.5 0 2.249 0 2.848.21.962.338 1.721 1.052 2.08 1.958.224.564.224 1.27.224 2.68V10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M2.5 10a2.78 2.78 0 0 1 2.778-2.778c.555 0 1.209.097 1.748-.047.48-.129.854-.503.982-.982.145-.54.048-1.194.048-1.749a2.78 2.78 0 0 1 2.777-2.777"
    />
  </svg>
);
export default SvgFileSearch;
